import * as PIXI from 'pixi.js';
import { IAnimationDependencies, IAnimation } from 'js/bubbleCore/view/animations/types';
import { fillAnimationDependencies } from 'js/bubbleCore/view/animations/fillAnimationDependencies';
import { Lerper } from 'framework/utils/Lerper';
import { Range } from 'framework/utils/Range';

export function createFireParticle(
  dependencies: Partial<IAnimationDependencies> = {},
): IAnimation<PIXI.Sprite> {
  const { spritePool, tweenMgr, rnd } = fillAnimationDependencies(dependencies);

  const root = spritePool.getInstance().props({
    anchor: 0.5,
    scale: 0.5,
    texture: 'fire_part',
    blendMode: PIXI.BLEND_MODES.ADD,
  });

  const scaleLerper = new Lerper({
    initValue: 0.5,
    lerp: 0.2,
    autoUpdate: true,
    range: new Range(0.2, 0.8),
    destroySignal: root.onReleased,
  });
  scaleLerper.signals.onValueUpdate.add((value) => root.scale.set(value));
  scaleLerper.signals.onUpdate.add(([current, target]) => {
    scaleLerper.setTarget(target + (Math.random() - 0.5) * 0.5);
  });

  const alphaLerper = new Lerper({
    initValue: 0.5,
    lerp: 0.2,
    autoUpdate: true,
    range: new Range(0.2, 0.8),
    destroySignal: root.onReleased,
  });
  alphaLerper.signals.onValueUpdate.add((value) => root.alpha = value);
  alphaLerper.signals.onUpdate.add(([current, target]) => {
    alphaLerper.setTarget(target + (Math.random() - 0.5) * 0.5);
  });

  const cancel = () => spritePool.release(root);

  return { root, onCompleteAsync: Promise.resolve() , cancel };
}